<template>
  <div>
    <!--    <page-header></page-header>-->

    <div>
      <!-- 화면 타이틀 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="icon-title word-type pb-5">
          <icon-policy :width="22" :height="22" />
          서비스 이용약관
        </v-col>
      </v-row>

      <!-- 서비스 이용약관 내용 -->
      <v-row
        class="ma-0 overflow-y-auto"
        :class="$store.getters.IS_IOS ? 'pb-5' : ''"
      >
        <v-col cols="12" class="pa-0">
          <service-accordion-list />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
/* 서비스이용약관 (최초동의) */
//import PageHeader from '@/components/common/PageHeader.vue';
import IconPolicy from '@/assets/customIcon/IconPolicy.vue';
import ServiceAccordionList from '@/components/settings/policy/ServiceAccordionList.vue';

export default {
  computed: {},
  components: { IconPolicy, ServiceAccordionList },
};
</script>

<style></style>
